import dayjs from 'dayjs';
import { IHourTransaction, IWeeklyTransaction } from '../../../interface/transaction';
import { formatter } from '../../../constants/utilityFunctions';

const joinRange = (first: string, last: string) => (first === last ? first : `${first} - ${last}`);

const compareWeeks = (a: IWeeklyTransaction, b: IWeeklyTransaction) =>
  a.year - b.year || a.weekNumber - b.weekNumber;

export const formatChartDateRange = (transactions: IHourTransaction[]): string | undefined => {
  if (transactions.length === 0) return undefined;
  const dates = transactions
    .map((transaction) => transaction.transactionDate)
    .sort((a, b) => a.localeCompare(b));
  const formatDate = (date: string) => formatter.dateWithoutYear(dayjs(date).toDate());
  return joinRange(formatDate(dates[0]), formatDate(dates[dates.length - 1]));
};

export const formatChartWeekRange = (
  weeks: IWeeklyTransaction[],
  weekLabel: string,
): string | undefined => {
  if (weeks.length === 0) return undefined;
  const sortedWeeks = [...weeks].sort(compareWeeks);
  const firstWeek = String(sortedWeeks[0].weekNumber);
  const lastWeek = String(sortedWeeks[sortedWeeks.length - 1].weekNumber);
  return `${weekLabel} ${joinRange(firstWeek, lastWeek)}`;
};
